import * as React from "react";
const SvgArrow = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M12 14.25 6.405 8.5 12 2.75 10.297 1 3 8.5l7.297 7.5z" /></svg>;
export default SvgArrow;